import { Copy, Linkedin, MessageCircle, Send, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M18.9 2H22l-7.3 8.3L23 22h-6.8l-5.3-6.9L4.8 22H1.7l7.8-8.9L0 2h7l4.8 6.3L18.9 2zm-1.2 18h1.9L6.4 3.9H4.4L17.7 20z" /></svg>
);

export const shareTargets = (url, text) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return [
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${t}%20${u}`, cls: "hover:bg-[#25D366] hover:text-slate-950 hover:border-[#25D366]" },
    { id: "telegram", label: "Telegram", icon: Send, href: `https://t.me/share/url?url=${u}&text=${t}`, cls: "hover:bg-[#2AABEE] hover:text-slate-950 hover:border-[#2AABEE]" },
    { id: "linkedin", label: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, cls: "hover:bg-[#0A66C2] hover:text-white hover:border-[#0A66C2]" },
    { id: "x", label: "X", icon: XIcon, href: `https://twitter.com/intent/tweet?text=${t}&url=${u}`, cls: "hover:bg-white hover:text-slate-950 hover:border-white" },
  ];
};

export const SocialShare = ({ url, text, prefix = "share", compact = false }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Link copiato!");
    setTimeout(() => setCopied(false), 2000);
  };
  const base = `inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] text-sm font-semibold text-slate-200 transition-colors duration-200 ${compact ? "px-3.5 py-2" : "px-4 py-2.5"}`;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${prefix}-social-row`}>
      {shareTargets(url, text).map(({ id, label, icon: Icon, href, cls }) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-${id}-btn`} className={`${base} ${cls}`}>
          <Icon className="w-4 h-4" /> {label}
        </a>
      ))}
      <button type="button" onClick={copy} data-testid={`${prefix}-copy-btn`} className={`${base} hover:border-amber-500/60 hover:text-amber-300`}>
        {copied ? <Check className="w-4 h-4 text-emerald-400" /> : <Copy className="w-4 h-4" />} {copied ? "Copiato" : "Copia link"}
      </button>
    </div>
  );
};
